import React, { useState } from 'react';
import { useEditorClient } from '../contexts/EditorClientContext';
import { ChevronDownIcon } from "@/components/icons";

export const EditorClientSelector: React.FC = () => {
  const { currentClientId, currentClientName, clients, isLoading, selectClient } = useEditorClient();
  const [isOpen, setIsOpen] = useState(false);

  const handleClientSelect = (clientId: string) => {
    setIsOpen(false);
    if (clientId !== currentClientId) {
      selectClient(clientId);
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center space-x-2 px-3 py-2 bg-gray-100 rounded-lg">
        <div className="w-3 h-3 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin" />
        <span className="text-sm text-gray-600">Loading clients...</span>
      </div>
    );
  }

  if (!currentClientName && clients.length === 0) {
    return null;
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
      >
        <span className="font-medium text-gray-700">
          {currentClientName || 'Select Client'}
        </span>
        <ChevronDownIcon className={`w-4 h-4 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-30 max-h-96 overflow-y-auto">
            <div className="py-1">
              {clients.map((client) => (
                <button
                  key={client.id}
                  onClick={() => handleClientSelect(client.id)}
                  className={`w-full text-left px-4 py-3 text-sm hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0 ${
                    currentClientId === client.id
                      ? 'bg-indigo-50 text-indigo-700 font-medium'
                      : 'text-gray-700'
                  }`}
                >
                  {client.clientName}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
